import type { RouteRecordRaw } from "vue-router";

const contractsRoutes: RouteRecordRaw[] = [
  {
    path: "/bookings/view",
    name: "view-bookings",
    component: () => import("@/views/Contracts/ViewBookings.vue"),
    meta: {
      title: "View Bookings",
      requiresAuth: true,
      contractsPermission: "viewBookings",
    },
  },
  {
    path: "/prepaids/view",
    name: "view-prepaids",
    component: () => import("@/views/Contracts/ViewPrepaids.vue"),
    meta: {
      title: "View Prepaids",
      requiresAuth: true,
      contractsPermission: "viewPrepaids",
    },
  },
];

export default contractsRoutes;
